import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getStoredTags.query';

export const getStoredTags = ({ customerId, projectId, contractId }: QueryParams) => {
    const querystring = qs.stringify({ customerId, projectId, contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredTags${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
